export default __webpack_public_path__ + "assets/546a66e5026d26279aedb6a9a26e37a0-empty-search.svg";